import React, { Component } from 'react';
import '../css/App.css';
import '../css/fonts.css';
import '../css/addlightness.css';


export class Mousetrap extends Component {
  constructor(props) {
    super(props)

    this.state = {
      //showDescription: false,
      showDescription: true,
    }

    this.hovered = this.hovered.bind(this)
    this.unHovered = this.unHovered.bind(this)

    this.renderAppDescriptionBox = this.renderAppDescriptionBox.bind(this)
  }


  hovered(elem) {
    console.log("Mousetrap hovered()")
    this.setState({ showDescription: true })
  }

  unHovered(elem) {
    this.setState({ showDescription: false })
  }

  renderAppDescriptionBox() {
    //console.log("renderAppDescriptionBox()")
    const description = "Rails app, a work ticket tracker to replace jira. Hotwire / Turbo / Stimulus. The latest Rails tech !"
    return (
      <div className='idea-description'>
        { description }
      </div>
    )
  }


  render() {

    return (
      <div className="idea-container">
        <div className="idea-row">
          <div className="idea-row-item">
            <div className="idea-box">
              <a href="https://mousetrap-demo-250ae52dbe15.herokuapp.com/tickets">
              Mousetrap on Rails
              </a>
            </div>
          </div>
          <div className="idea-row-item">
            <div className="tool-description-container">
              { this.state.showDescription
                ? this.renderAppDescriptionBox()
                : null
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}
